export const DONT_HAVE_APP = {
  EN: "Don't have the app yet?",
  TH: 'ยังไม่มีแอป?',
};

export const DOWNLOAD_APPLE_STORE = {
  EN: 'Download on Apple App Store',
  TH: 'ดาวน์โหลดจากแอปสโตร์ของแอปเปิล',
};

export const DOWNLOAD_PLAY_STORE = {
  EN: 'Download on Google Play Store',
  TH: 'ดาวน์โหลดจากเพลย์สโตร์ของกูเกิล',
};

export const OPEN_APP = {
  EN: 'Open App',
  TH: 'เปิดแอป',
};
